export default __webpack_public_path__ + "static/media/no-data-available.0f80bcfe.svg";